<div (click)="containerClicked($event);" #graphContainer></div>